import { isProduction } from './constants';

export const fbqId = '307516364602655';

export const appVersion = '1.0.0';
export const appName = 'Roborovski NFT';

export const ALCHEMY_API_MAINNET = '9tNnSTTB5lBond6jhoiqnITlwxOdhtX1';
export const ALCHEMY_API_RINKEBY = 'oN7vvPVLdnPq1E7_acUPnax5uVZUKdg3';
export const ALCHEMY_API = ALCHEMY_API_RINKEBY;
export const networkChainId = 1; // TODO // 1 - mainnet, 4 - rinkeby
export const pollingInterval = 10000;

export const apiKey = '33488d02-88f2-43da-b440-9dcc95c7fa1e';
export const rootDomain = isProduction ? 'https://roborovski.org' : `http://${window.location.hostname}:3000`;
export const apiDomain = isProduction ? 'https://api.roborovski.org' : `http://${window.location.hostname}:3100`;

export const youtubeShortFilmUrl = 'http://static.roborovski.org.s3-website.us-east-2.amazonaws.com/video/ROBOROVSKI_1080p.mp4';
export const youtubeMintUrl = 'https://www.youtube.com/watch?v=TS_IFQBstdo&autoplay=1';
export const youtubeTeaserUrl = 'https://www.youtube.com/watch?v=gAU7M1LnXow&autoplay=1';
export const youtubeUrl = 'https://www.youtube.com/channel/UCeBF9kCViNqs3-kAQCbaYRg';

export const facebookUrl = `https://www.facebook.com/roborovskiNFT/`;
export const instagramUrl = `https://www.instagram.com/roborovskiNFT/`;
export const twitterUser = `ROHamsters`;
export const twitterUrl = `https://twitter.com/${twitterUser}`;
//export const telegramUrl = 'https://t.me/?';
export const discordUrl = 'https://discord.gg/roborovskinft';
export const openSeaUrl = 'https://opensea.io/collection/roborovski-nft';
export const raribleUrl = 'https://rarible.com/roborovski-nft/items';

export const syaConceptUrl = 'https://www.syaconcept.com/';
export const caravanStudioUrl = 'https://caravanstudio.com/';
export const spectreStudiosUrl = 'https://www.spectrestudios.com.au/';
export const roobiniumUrl = 'https://roobinium.io/';


export const ipfsPrfix = 'https://ipfs.roborovski.org/ipfs/';

export const mintRequestPowTarget = parseInt('00ffffff', 16);


export const startOfPresaleTimestamp = Math.trunc(new Date(
  '2022-02-19T14:00:00.000Z' // TODO
).getTime() / 1000);
export const endOfPresaleTimestamp = Math.trunc(new Date(
  '2022-02-20T02:00:00.000Z' // TODO
).getTime() / 1000);
/*export const endOfRaffleTimestamp = Math.trunc(new Date(
  '2022-02-20T08:00:00.000Z' // TODO
).getTime() / 1000);*/
export const startOfSaleTimestamp = Math.trunc(new Date(
  '2022-02-20T08:00:00.000Z' // TODO
).getTime() / 1000);


export const SOLD_OUT = true;
export const MAX_SUPPLY = 7777;

export const TIMESTAMP_PRESALE = startOfPresaleTimestamp;
export const TIMESTAMP_PRESALE_END = endOfPresaleTimestamp;
//export const TIMESTAMP_RAFFLE_END = endOfRaffleTimestamp;
export const TIMESTAMP_SALE = startOfSaleTimestamp;


export const PRICE_PRESALE = 0.165; // TODO 0.165
export const PRICE_SALE = 0.165; // TODO 0.2

export const LIMIT_PRESALE = 1; // TODO
export const LIMIT_SALE = 2; // TODO


// https://etherscan.io/token/0x2c5E6FFE9f7f161C15f78Cd67D79c33A7c8D84B5
export const rnctMainnetAddress = '0x2c5E6FFE9f7f161C15f78Cd67D79c33A7c8D84B5'; // TODO
export const rnctRinkebyAddress = null; // TODO

// https://etherscan.io/token/0x4CEB477A068350BC652caBFf127f87AD874B11F9
export const nftMainnetAddress = '0x4CEB477A068350BC652caBFf127f87AD874B11F9'; // TODO
export const nftRinkebyAddress = null; // TODO


export const nftBurnMainnetAddress = '0x6B7ed5E55e831c67Ba2Ba05773E5F0CbB4BdEA37'; // TODO
export const nftBurnRinkebyAddress = null; // TODO

export const royaltyDistributorMainnetAddress = null; // TODO
export const royaltyDistributorRinkebyAddress = null; // TODO


export const metadataStoreMainnetAddress = '0xfe804587844528E46e6794B5e1494af7364690b1';
export const traitsMainnetAddress = '0xb336a3f717882fd7e70DCB66228f9005A50Fa5c5';
